module.exports = __webpack_public_path__ + "img/sfondo-pera.20c18014.png";